import { range } from "d3-array";
import { scaleBand, scaleLinear } from "d3-scale";

interface DataPoint {
  value: number;
}

interface Margin {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

// Function used for y-axis within Axis and Bars components
export function yBarHelper(data: DataPoint[], margin: Margin, height: number) {
  return scaleLinear()
    .domain([0, Math.max(...data.map((d) => d.value))])
    .nice()
    .range([height - margin.bottom, margin.top]);
}

// Function used for x-axis within Axis and Bars components
export function xBarHelper(data: DataPoint[], margin: Margin, width: number) {
  return scaleBand()
    .domain(range(data.length).map((i) => i.toString()))
    .range([margin.left, width - margin.right])
    .padding(0.4);
}

export function chartWidth(width: number, margin: Margin): number {
  return width - margin.right;
}

export function translateTo(
  x: number = 0,
  y: number = 0,
  xOffSet: number = 0,
  yOffSet: number = 0
): string {
  return "translate(" + (x + xOffSet) + "," + (y + yOffSet) + ")";
}
